/**
 * 采集浏览器端系统环境信息，序列化为 JSON 字符串。
 * 获取不到 navigator 时回退为 'web'。
 *
 * 供 browser/taro/uni 三个运行时在 H5 场景共享调用。
 */
export function collectBrowserSystemInfo(): string {
  try {
    if (typeof navigator === 'undefined') return 'web';

    const info: Record<string, string> = {
      userAgent: navigator.userAgent || '',
      platform: navigator.platform || '',
      language: navigator.language || '',
    };

    // 屏幕信息安全读取
    if (typeof screen !== 'undefined') {
      info.screenResolution = `${screen.width || 0}x${screen.height || 0}`;
    }

    return JSON.stringify(info);
  } catch {
    return 'web';
  }
}
